import { TYPE_COLLECTION } from './input-types';
import { PICKING_EXCEPTION } from '../constants';

export const id = PICKING_EXCEPTION;
export const apiKey = 'PickBatchExceptionType';
export const type = TYPE_COLLECTION;

type FilterOption = {
  id: string;
  apiKey: string;
  type: string;
};

export const pickingExceptionFilter: FilterOption = {
  id,
  apiKey,
  type,
};
